import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Flex, Text, Divider } from 'pcln-design-system'

import { WidthSkeleton } from '../WidthSkeleton'

const FilterFlex = styled(Flex)`
  max-width: 224px;
  width: 100%;
`

// eslint-disable-next-line react/prop-types
function CheckboxRow({ width }) {
  return (
    <Flex mb={'8px'}>
      <WidthSkeleton width={'18px'} height={'18px'} mr={'12px'} />
      <WidthSkeleton width={width} height={'18px'} mr={'24px'} />
    </Flex>
  )
}

function FilterGroup() {
  return (
    <Flex alignItems={'flex-start'} mb={'38px'} flexDirection={'column'} align={'left'}>
      <WidthSkeleton width={'120px'} height={'18px'} mr={'24px'} mb={'8px'} />
      <CheckboxRow width={'180px'} />
      <CheckboxRow width={'150px'} />
      <CheckboxRow width={'180px'} />
      <CheckboxRow width={'150px'} />
    </Flex>
  )
}

const SECTION_TITLES = ['Stops', 'Time', 'Duration', 'Airlines', 'Airports']

export function FilterSkeleton({ repeat, showTitles, sectionTitles, className }) {
  const count = repeat > 0 ? repeat : 1

  return (
    <FilterFlex className={className} flexDirection={'column'} px={1} pb={2}>
      {[...Array(count)].map((x, idx) => (
        <div key={idx} data-testid={`filter-skeleton-container-${idx}`}>
          {showTitles && (
            <React.Fragment>
              {sectionTitles[idx] && (
                <Text bold color={'text.light'} fontSize={2} mb={2}>
                  {sectionTitles[idx]}
                </Text>
              )}
              <Divider mb={2} />
            </React.Fragment>
          )}
          <FilterGroup />
        </div>
      ))}
    </FilterFlex>
  )
}

FilterSkeleton.defaultProps = {
  repeat: 3,
  sectionTitles: SECTION_TITLES,
}

FilterSkeleton.propTypes = {
  repeat: PropTypes.number,
  showTitles: PropTypes.bool,
  sectionTitles: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
}
